import { mapState } from 'vuex';

export default {
    name: 'wai_symptoms',
    props: {
        symptoms : Object,
        manage : Boolean,
        details : Array,
        classification : String
    },

    components: {
                 
    },    

    data : function(){

        return {
            loading : false,
            addShowed : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        l : function(state){
            return this.$root.platform.language.get()
        }
    }),

    methods : {

        plusminus : function(cui){

            var s = ''

            _.each(this.details, (d) => {
                _.each(d.concepts, (c) => {

                    if(cui == c.CUI){
                        if(c.negated){
                           s = s + "-"
                        }
                        else{
                            s = s + '+'
                        }
                    }

                    
                })
            })

            return s
        },

        cuiName : function(obj){


            return this.$root.f.flball(
                /*this.$f.deep(this.$store, 'state.cache.CUINAME' + this.l +'.' + obj.CUI + ".str") ||*/ obj.CUIName || obj.Name
            )
        },
        remove : function(cui){

            /*this.value = _.filter(this.value, function(v){
                return v.CUI != cui
            })*/

            this.$emit('remove', cui)
        },

        add : function(result){
            this.addShowed = false
            this.$emit('add', result)
        },

        showAddSymptoms : function(){
            this.addShowed = true

            var ref = this.$refs.search


            setTimeout(function(){

                if (ref){
                    ref._focus()
                }

            }, 250)
        },

        hideAddSymptoms : function(){
            this.addShowed = false
        },

        showHideAddSymptoms : function(){
            if(!this.addShowed){
                this.showAddSymptoms()
            }
            else{
                this.hideAddSymptoms()
            }
        },
    },
}